// extracted by mini-css-extract-plugin
module.exports = {"header":"g0","headerBg":"g1"};